import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import * as svg from 'polotno/utils/svg';
import AiOutlineBarcode from '@meronex/icons/ai/AiOutlineBarcode';
import { Button, InputGroup } from '@blueprintjs/core';
import JsBarcode from 'jsbarcode';
import bwipjs from 'bwip-js';



// create svg image for QR code for input text
export async function getBarcode(text) {
  const xmlSerializer = new XMLSerializer();

  //const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  //JsBarcode(svgNode, text);

  //const svgText = xmlSerializer.serializeToString(svgNode);
  let svgText = bwipjs.toSVG({
        bcid:        'code128',       // Barcode type
        text:        '0123456789',    // Text to encode
        height:      12,    
        width:      24,           // Bar height, in millimeters
        includetext: true,            // Show human-readable text
        textxalign:  'center',        // Always good to set this
        textcolor:   'ff0000',        // Red text
    });
  //const svgText = '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"> <circle cx="50" cy="50" r="50" /> </svg>'
  const src = svg.svgToURL(svgText);
  
  const { width, height } = await svg.getSvgSize(src);
  console.log("SVG", width, height)
  let width2 = "300px";
  return {
    src,
    width2,
    height,
  };
}

// define the new custom section
export const BarcodeSection = {
  name: 'barcode',
  Tab: (props) => (
    <SectionTab name="Barcode" {...props}>
      <AiOutlineBarcode />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [val, setVal] = React.useState('');

    const el = store.selectedElements[0];
    const isBarcode = el?.name === 'barcode';

    // if selection is changed we need to update input value
    React.useEffect(() => {
      if (el?.custom?.value) {
        setVal(el?.custom.value);
      }
    }, [isBarcode, el]);

    // update image src when we change input data
    React.useEffect(() => {
      if (isBarcode && val) {
        getBarcode(val).then(({ src }) => {
          el.set({
            src,
            custom: {
              value: val,
            },
          });
        });
      }
    }, [el, val, isBarcode]);

    return (
      <div>
        {isBarcode && <p>Update select bar code:</p>}
        {!isBarcode && <p>Create new bar code:</p>}
        <InputGroup
          onChange={(e) => {
            setVal(e.target.value);
          }}
          placeholder="Type bar code content"
          value={val}
          style={{ width: '100%' }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '20px',
          }}
        >
          <Button
            style={{
              display: isBarcode ? '' : 'none',
            }}
            onClick={() => {
              store.selectElements([]);
              setVal('');
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              display: isBarcode ? 'none' : '',
            }}
            onClick={async () => {
              const { src, width, height } = await getBarcode(val);
              let width2 = 200;
              let height2 = 100
              store.activePage.addElement({
                type: 'svg',
                name: 'barcode',
                x: 50,
                y: 50,
                width: width2,
                height: height2,
                src,
                custom: {
                  value: val,
                  type: "ean13"
                },
              });
            }}
          >
            Add new Barecode
          </Button>
        </div>
      </div>
    );
  }),
};
